//@ts-check
import React, { useState, useEffect } from 'react';
import { usePromise } from '../../_shared/react-hooks';
import { padStart, debounce } from 'lodash-es';
import { isInGeotarget } from '../../../utils/location';
import { MOBILE_BREAKPOINT } from '../../../utils/constants';
import { IPdpData } from '../types/PDP';

const VirtualStylingHelp = (props: { pdpData: IPdpData }) => {
  const [showNumber, setShowNumber] = useState(false);
  const { data: isInUS, isLoading } = usePromise(() => isInGeotarget({ countries: ['US'] }));

  const [width, setWidth] = useState(document.documentElement.clientWidth);
  useEffect(() => {
    const redefineWidth = debounce(() => setWidth(document.documentElement.clientWidth), 250);
    if (isInUS) {
      window.addEventListener('resize', redefineWidth);
    }
    return () => {
      window.removeEventListener('resize', redefineWidth);
    };
  }, [isInUS]);

  if (isLoading || !isInUS) return null;

  const isMobile = width < MOBILE_BREAKPOINT;

  const { pdpHeader, pdpMessage, phoneMessage, phoneNumber } = props.pdpData.pdpProductShell.stylistChat;

  // if we get here phone number should always be defined, try to bake that into TS
  const smsNumber = padStart((phoneNumber || '').replace(/[^0-9]/g, ''), 11, '1');
  const smsBody = encodeURI(`${window.location.href}\n\n${phoneMessage}`);
  const smsHref = `sms:+${smsNumber};?&body=${smsBody}`;

  return (
    <div className="VirtualStylingHelp">
      <h6 className="list-header">{pdpHeader}</h6>
      <div className="small-p">{pdpMessage}</div>

      <div className="call-to-action-wrapper">
        {isMobile ? (
          <a className="btn btn-transparent send-us-a-message link-styled-as-button" href={smsHref}>
            SEND US A MESSAGE
          </a>
        ) : showNumber ? (
          <a className="click-to-text" href={smsHref}>
            <b>TEXT: </b>
            {phoneNumber}
          </a>
        ) : (
          <button onClick={() => setShowNumber(true)} className="btn btn-transparent send-us-a-message">
            SEND US A MESSAGE
          </button>
        )}
      </div>
    </div>
  );
};
export default VirtualStylingHelp;
